import { createUseStyles } from 'react-jss'

const ranRoomCardStyles = createUseStyles(theme => ({
  backButton: {
    float: 'left',
    marginLeft: 0,
  }
}))

export default ranRoomCardStyles
